//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('datatableHeader',
        () => ({
          restrict: 'E',
          scope: {},
          require: '^datatable',
          compile(element) {
            const ele = angular.element('<div class="datatable-header"></div>');
            const insides = element.contents();
            const directionButtonInclusion = element.find('[include-direction-button]');
            let directionContainer;
            let directionButton;

            ele.append(insides);

            if (directionButtonInclusion.length > 0) {
              directionContainer = angular.element('<div class="pull-right text-right no-padding"></div>');
              directionButton = angular.element('<button class="btn btn-prim-inverse sortable"></button>');
              directionButton.attr('ng-class', '{"sort-asc": model.sorting.direction === "asc", "sort-desc": model.sorting.direction === "desc" }');
              directionButton.attr('ng-bind', 'model.sorting.direction === "asc"  ? "Ascending" : "Descending"');
              directionButton.attr('ng-click', 'model.changeSortDirection()');
              directionButton.attr('ng-disabled', 'model.loading');
              directionContainer.append(directionButton);
              directionButtonInclusion.replaceWith(directionContainer);
            }

            return {
              pre: null,
              post(scope, elem, attrs, datatable) {
                datatable.registerHeaderView(ele);
              },
            };
          },
        }),
    );
})();
